import { TierIiReportVerifier } from "generated-graphql/graphql";

type AmazonVerifier = Required<
  Pick<
    TierIiReportVerifier,
    "verifierFullName" | "verifierTitle" | "verifierEmail" | "verifierPhone"
  >
>;

const AMAZON_EPCRA_EMAIL = "epcratier2@amazon.com";
const AMAZON_EPCRA_PHONE = "8005750171";

// Amazon's HMBP certifier for California differs from the verifier used for
// every other state's Tier II report.
const AMAZON_CA_VERIFIER: AmazonVerifier = {
  verifierFullName: "Nick Sharma",
  verifierTitle: "Sr. Mgr, Env Strategy",
  verifierEmail: AMAZON_EPCRA_EMAIL,
  verifierPhone: AMAZON_EPCRA_PHONE,
};

const AMAZON_NATIONAL_VERIFIER: AmazonVerifier = {
  verifierFullName: "Patricia Sullivan",
  verifierTitle: "Business Environmental Leader",
  verifierEmail: AMAZON_EPCRA_EMAIL,
  verifierPhone: AMAZON_EPCRA_PHONE,
};

/**
 * Amazon's report verifier is fixed per state and not editable by their users.
 * These names change with Amazon reorgs, so expect to update them year over year.
 */
export function getAmazonDefaultVerifier(facilityState: string | null | undefined): AmazonVerifier {
  if (facilityState === "CA") {
    return AMAZON_CA_VERIFIER;
  }
  if (facilityState === "NJ") {
    // NJ caps the verifier title at 21 characters.
    return { ...AMAZON_NATIONAL_VERIFIER, verifierTitle: "BEL" };
  }
  return AMAZON_NATIONAL_VERIFIER;
}
